<template>
  <div>
    <!-- Layout 구조를 여기서 잡아주시고, router-view는 page 들이 들어가는 곳입니다. -->
    <!-- 적절히 배치해주세요 -->

    <!-- 실제 페이지가 들어가는 부분 -->
    <ConnectedCarHeader/>
    <ProgressIndicator v-if="progress"/>
    <router-view />
    <DealerInfo v-if="dealer"/>
    <ConnectedCarFooter/>
  </div>
</template>

<script>
  import ConnectedCarHeader from '@/components/connectedCar/ConnectedCarHeader'
  import ProgressIndicator from '@/components/connectedCar/ProgressIndicator'
  import DealerInfo from '@/components/connectedCar/DealerInfo'
  import ConnectedCarFooter from '@/components/connectedCar/ConnectedCarFooter'

  export default {
    name: 'ConnectedCar',
    data () {
      return {
      }
    },
    components: {
      ConnectedCarHeader,
      ProgressIndicator,
      DealerInfo,
      ConnectedCarFooter,
    },
    created() {
    },
    mounted() {
      document.cookie="SameSite=None; Secure" //chorme 80 쿠키이슈 2020.08.24
    },
    computed: {
      dealer() {
        if(this.$route.name === 'ConnectedCarTerms') {
          return false
        }
        return true
      },
      progress() {
        if(this.$route.name === 'ConnectedCarTerms') {
          return false
        } else if (this.$route.name === 'ConnectedCar') {
          return false
        }
        return true
      },
    },
    methods: {
    }
  }
</script>

<style>

</style>
